import { User } from '../types'
import { getRequest, getRequestStatus, postRequest } from 'features/common'
import settings from 'settings'

function baseUrl() {
  const { accountsApiUrl } = settings
  return `${accountsApiUrl}/users`
}

export const getCurrentUser = async (): Promise<User> => {
  return await getRequest(`${baseUrl()}/me`)
}

export const addCartoDwGrant = async ({ email }: { email: string }): Promise<void> => {
  await postRequest(`${baseUrl()}/dw-access-grant`, { email })
}

export const revokeCartoDwGrant = async ({ email }: { email: string }): Promise<void> => {
  await postRequest(`${baseUrl()}/dw-access-revoke`, { email })
}

export const checkAccountIsReadyStatusInWorkspace = async (id: string): Promise<number> => {
  const { workspaceApiUrl } = settings

  const status = await getRequestStatus(`${workspaceApiUrl}/accounts/${id}/check`)
  return status
}

export const userLoginMetrics = async (user: User): Promise<void> => {
  const { workspaceApiUrl } = settings

  const metricsEndpointUrl = `${workspaceApiUrl}/events`
  await postRequest(metricsEndpointUrl, {
    event_type: 'UserLogins',
    payload: {
      accountId: user.user_metadata.account_id,
      userId: user.user_id
    },
    timestamp: new Date()
  })
}
